import React from 'react';
import { GiftIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
import { Button } from './ui/Button';
export function Bonuses() {
  return <section id="bonuses" className="bg-brand px-4 py-12 md:py-16" data-id="element-31" data-mp="asz34ehj8c2g">
      <div className="mx-auto max-w-3xl text-center" data-id="element-32" data-mp="fsv7wfy207j2">
        <GiftIcon className="mx-auto h-8 w-8 text-accent-light" aria-hidden="true" data-id="element-33" data-mp="1un53rec6bzz" />
        <h2 className="mt-3 text-2xl font-black uppercase leading-tight text-white md:text-4xl" data-id="element-34" data-mp="1wriczy4kncx">
          Includes <span className="text-accent-light" data-id="element-35" data-mp="3o1lferpctljg">5 practical bonuses</span>
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-4" data-id="element-36" data-mp="3t0ok2b1f9pqw">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-37" data-mp="3t2j4lo8s7fug" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-accent-light p-5 text-center" data-id="element-38" data-mp="1marurq0iee4l">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-white/85" data-id="element-39" data-mp="3ieg752qpk50b">
            Total reference value of the 5 bonuses
          </p>
          <span className="mt-1 text-3xl font-black text-white/85 line-through decoration-red-500 decoration-4" data-id="element-40" data-mp="3detuovipessk">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 text-lg font-black uppercase text-accent-light" data-id="element-41" data-mp="3n4wlcp2crunq">All 5 bonuses included free</p>
        </div>
        <div className="pt-4 text-center" data-id="element-42" data-mp="2zgdd29jazhvn">
          <Button href={offerAnchor} size="lg" subtext="Claim your $61 in bonuses before the launch price ends" data-id="element-43" data-mp="2zheyn7xy3mrm">
            Yes! Send me all 5 bonuses free
          </Button>
        </div>
      </div>
    </section>;
}